exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header-no-radius[data-v-b3cf3a98]{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.card-body-no-radius[data-v-b3cf3a98]{border-top-left-radius:0!important;border-top-right-radius:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b3cf3a98","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/system/clients/form.vue
// module id = +Q18
// module chunks = 0